import { render } from "./ListePromotionPage.vue?vue&type=template&id=6aeab381&ts=true"
import script from "./ListePromotionPage.vue?vue&type=script&lang=ts"
export * from "./ListePromotionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__